require('./bootstrap');

// require('alpinejs');
import Alpine from 'alpinejs';

window.Alpine = Alpine;

Alpine.start();

require('select2');


// Core - these two are required :-)
import tinymce from 'tinymce/tinymce';
import 'tinymce/themes/silver/theme';
// Plugins
import 'tinymce/plugins/paste/plugin';
import 'tinymce/plugins/link/plugin';
import 'tinymce/plugins/autoresize/plugin';
import 'tinymce/plugins/image/plugin';
import 'tinymce/plugins/autolink/plugin';
import 'tinymce/plugins/searchreplace/plugin';
import 'tinymce/plugins/imagetools/plugin';
import 'tinymce/plugins/media/plugin';
import 'tinymce/plugins/preview/plugin';
// import 'tinymce/plugins/pageembed/plugin';
// import 'tinymce/plugins/pdf/plugin';
import 'tinymce/plugins/lists/plugin';
import 'tinymce/plugins/code/plugin';

import Editor from '@toast-ui/editor'
// import 'codemirror/lib/codemirror.css';
import '@toast-ui/editor/dist/toastui-editor.css';

const editor = new Editor({
    el: document.querySelector('#editor'),
    height: '400px',
    initialEditType: 'markdown',
    placeholder: 'Write something cool!',
})

jQuery(document).ready(function($){
    if($('.select2-multiple').length > 0){
        let topCss;
        $('.select2-multiple')
            .select2({
                closeOnSelect: false
            })
            .on('select2:selecting select2:unselecting', function (evt) {
                var cur = evt.params.args.originalEvent.currentTarget;
                var value = evt.params.args.data.id;
                topCss = $(cur).closest('.select2-container')[0].style.top;

                if(value != 'all') {
                    $(this).find('option').first().removeAttr('selected');
                    // if($(this).select2('data')[0].id == 'all') {
                    //     $(this).val(value).change();
                    // }
                } else {
                    $(this).find('option').not(':first').removeAttr('selected');
                    $(this).val('all').change();
                }
            })
            .on('select2:select select2:unselect', function (evt) {
                let uldiv = $(this).siblings('span.select2').find('ul')
                let count = $(this).select2('data').length
                let values = $(this).val();
                var value = evt.params.data.id;

                if($('.select2-container:not(.select2)').length > 0){
                    $('.select2-container:not(.select2)')[0].style.top = topCss;
                }
                if(count!=0 && !$(this).find('option:selected').data('all')){
                    uldiv.html("<li>"+count+" items selected</li>");
                }
                if($(this).find('option:selected').data('all')){
                    $(this).find('option').not(':first').removeAttr('selected');
                    // $(this).find('option').not(':first').attr('disabled','disabled');
                    $(this).val('all').change();
                    $(this).addClass('selected-alldev');
                    // $(this).select2('destroy').select2({
                    //     closeOnSelect: false
                    // });
                }
                if(!$(this).find('option:selected').data('all')){
                    // $(this).find('option').removeAttr('disabled');
                    $(this).removeClass('selected-alldev');
                }
                if($(this).select2('data')[0].id == 'all') {
                    $(this).find('option').first().removeAttr('selected');
                    $(this).val(value).change();
                }
            })
            .on('select2:unselecting', function (evt) {
                let values = $(this).val();
                if($(this).find('option:selected').data('all')){
                    // $(this).select2('destroy').select2({
                    //     closeOnSelect: false
                    // });
                }
            })

        $(".select2-multiple").each(function (i, e) {
            let uldiv = $(e).siblings('span.select2').find('ul');
            let count = $(this).select2('data').length;

            if(count!=0 && !$(this).find('option:selected').data('all')){
                uldiv.html("<li>"+count+" items selected</li>");
            }
        });

        $(this).find('option').removeAttr('disabled');
    }
});
